/**
 * Format amount in pence to currency string (GBP)
 */
export function formatCurrency(pence) {
    const pounds = pence / 100;
    return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
    }).format(pounds);
}
/**
 * Format ISO date string to readable format
 */
export function formatDate(isoString, options) {
    const date = new Date(isoString);
    return new Intl.DateTimeFormat('en-GB', {
        dateStyle: 'long',
        ...options,
    }).format(date);
}
/**
 * Format ISO date string to datetime format
 */
export function formatDateTime(isoString) {
    const date = new Date(isoString);
    return new Intl.DateTimeFormat('en-GB', {
        dateStyle: 'medium',
        timeStyle: 'short',
    }).format(date);
}
/**
 * Format file size in bytes to human readable string
 */
export function formatFileSize(bytes) {
    const units = ['B', 'KB', 'MB', 'GB'];
    let size = bytes;
    let unitIndex = 0;
    while (size >= 1024 && unitIndex < units.length - 1) {
        size /= 1024;
        unitIndex++;
    }
    return `${size.toFixed(unitIndex === 0 ? 0 : 1)} ${units[unitIndex]}`;
}
//# sourceMappingURL=format.js.map